import React from 'react';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import TopbarNotification from './TopbarNotification';
import { TopbarContainer, TopbarLeft, TopbarLogo, TopbarRight, TopbarRightOver } from './BasicTopbarComponents';

const Topbar = ({
  changeMobileSidebarVisibility,
  changeSidebarVisibility,
  isSidebarOpen
}) => <TopbarContainer>
    <TopbarLeft>
      <TopbarSidebarButton onClickMobile={changeMobileSidebarVisibility} onClickDesktop={changeSidebarVisibility} isSidebarOpen={isSidebarOpen} />
      <TopbarLogo to="/" />
    </TopbarLeft>
    <TopbarRight>
      <TopbarRightOver>
        <TopbarNotification />
        <TopbarProfile />
      </TopbarRightOver>
    </TopbarRight>
  </TopbarContainer>;

Topbar.propTypes = {
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
  changeSidebarVisibility: PropTypes.func.isRequired,
  isSidebarOpen: PropTypes.bool.isRequired
};
export default Topbar;
